import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  spectrophotometerToggleLid,
  spectrophotometerToggleSettingsModal,
  spectrophotometerToggleInfoModal,
  spectrophotometerRemoveCuvette,
  spectrophotometerOnClickPowerButton,
  spectrophotometerOnClickZeroButton,
  spectrophotometerSetWavelength,
  spectrophotometerItemDrop,
  setCuvettesInScene,
  absorbanceTableCellUpdate,
  questionTableCellUpdateResults
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].type,
    lidOpen: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].lidOpen,
    showSettingsModal: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].showSettingsModal,
    showInfoModal: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].showInfoModal,
    cuvetteId: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].cuvetteId,
    absorbanceValue: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].absorbanceValue,
    relativeAbsorbance: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].relativeAbsorbance,
    poweredUp: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].poweredUp,
    wavelength: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].wavelength,
    solution: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].solution,
    absorbanceTable: state.notebook.protocolSection.scene.absorbanceTable,
    notebookCollapsed: state.notebook.notebookCollapsed
  }
}

function mapDispatchToProps(dispatch) {
  return {
    toggleLid: (data)=>{
      dispatch(spectrophotometerToggleLid(data))
    },
    toggleSettingsModal: (data)=>{
      dispatch(spectrophotometerToggleSettingsModal(data))
    },
    toggleInfoModal: (data)=>{
      dispatch(spectrophotometerToggleInfoModal(data))
    },
    removeCuvette: (data)=>{
      dispatch(spectrophotometerRemoveCuvette(data))
    },
    onClickPowerButton: (data)=>{
      dispatch(spectrophotometerOnClickPowerButton(data))
    },
    onClickZeroButton: (data)=>{
      dispatch(spectrophotometerOnClickZeroButton(data))
    },
    setWavelength: (data)=>{
      dispatch(spectrophotometerSetWavelength(data))
    },
    onDropItem: (data)=>{
      dispatch(spectrophotometerItemDrop(data))
    },
    setCuvettesInScene: (data) => {
      dispatch(setCuvettesInScene(data))
    },
    absorbanceTableCellUpdate: (data) => {
      dispatch(absorbanceTableCellUpdate(data))
    },
    questionTableCellUpdateResults: (data) => {
      dispatch(questionTableCellUpdateResults(data))
    },
    };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
